import { PolicyHolder } from "@/shared/domain";

export const getPhysicalPolicyholders = (policyholders: PolicyHolder[]): PolicyHolder[] =>
    (policyholders || []).filter((policyholder) => !!policyholder.isPhysicalPerson);

export const getMoralPolicyholders = (policyholders: PolicyHolder[]): PolicyHolder[] =>
    (policyholders || []).filter((policyholder) => !policyholder.isPhysicalPerson);

export const existSomePhysicalPolicyholder = (policyholders: PolicyHolder[]): boolean =>
    (policyholders || []).some((policyholder) => !!policyholder.isPhysicalPerson);

export const existSomeMoralPolicyholder = (policyholders: PolicyHolder[]): boolean =>
    (policyholders || []).some((policyholder) => !policyholder.isPhysicalPerson);
